<template>
  <div style="width: 100%;">
    <span v-if="show">
      <v-card v-if="card" :outlined="outlined" style="width: 100%;">
        <v-card-text style="width: 100%;" class="d-flex flex-row">
          <span v-if="mainLoader">
            <v-progress-circular
              indeterminate
              color="info"
              small
            ></v-progress-circular>
          </span>
          <div v-else class="d-flex flex-row flex-wrap">
            <div v-for="(button, index) in dynamicButtons" :key="index" class="d-flex flex-row mr-2 mb-2">
              <span v-if="button.tile">
                <v-btn 
                  v-bind="$attrs"
                  :to="button.requestEndpoint"
                  :style="'width: 150px; height: 150px; background-color:'+(button.color || '#1C90FF')+'; border-radius: 7px; font-size: 16px;'" 
                  class="d-flex flex-row align-center justify-center"
                >
                  {{button.name}}
                </v-btn>
              </span>
              <v-tooltip v-else :disabled="!button.description" bottom max-width="200px" open-delay="800">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    v-if="!button.requireConfirm"
                    :fab="button.fab"
                    :text="button.text"
                    :loading="btnLoaders[index]"
                    :color="button.color" 
                    :class="button.classes" 
                    :small="button.size == 'small'" 
                    :x-small="button.size == 'x-small'" 
                    :large="button.size == 'large'" 
                    :x-large="button.size == 'x-large'"
                    :disabled="btnDisabled(button)"
                    @click="confirm(index)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon v-if="button.fabIcon">{{ button.fabIcon }}</v-icon>
                    <span class="ml-1" v-if="!button.fab">{{ button.name }}</span>
                  </v-btn>
                  <confirmedActionButton
                      v-else
                      :class="button.classes"
                      :color="button.color"
                      :text="button.text"
                      :small="button.size == 'small'"
                      :x-small="button.size == 'x-small'"
                      :large="button.size == 'large'" 
                      :x-large="button.size == 'x-large'" 
                      :buttonText=button.name
                      :requireUsername="button.requireUsername"
                      :requirePassword="button.requirePassword"
                      :loading="btnLoaders[index]"
                      @cb="confirm(index)"
                      :fab="button.fab"
                      :fabIcon="button.fabIcon"
                      :disabled="btnDisabled(button)"
                      :dialogText="button.dialogText"
                  />
                </template>
                <span>{{ button.description?button.description:""}}</span>
              </v-tooltip>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <div v-else class="d-flex flex-row mr-1">
        <span v-if="mainLoader">
          <v-progress-circular
            indeterminate
            color="info"
            small
          ></v-progress-circular>
        </span>
        <div v-else class="d-flex flex-row">
          <div v-for="(button, index) in dynamicButtons" :key="index" class="d-flex flex-row">
            <v-tooltip :disabled="!button.description" bottom max-width="200px" open-delay="800">
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  v-if="!button.requireConfirm"
                  :fab="button.fab"
                  :text="button.text"
                  :loading="btnLoaders[index]"
                  :color="button.color" 
                  :class="button.classes" 
                  :small="button.size == 'small'" 
                  :x-small="button.size == 'x-small'" 
                  :large="button.size == 'large'" 
                  :x-large="button.size == 'x-large'"
                  :disabled="btnDisabled(button)"
                  @click="confirm(index)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon v-if="button.fabIcon">{{ button.fabIcon }}</v-icon>
                  <span class="ml-1" v-if="!button.fab">{{ button.name }}</span>
                </v-btn>
                <confirmedActionButton
                    v-else
                    :class="button.classes"
                    :color="button.color" 
                    :small="button.size == 'small'"
                    :x-small="button.size == 'x-small'"
                    :large="button.size == 'large'" 
                    :x-large="button.size == 'x-large'" 
                    :buttonText=button.name
                    :requireUsername="button.requireUsername"
                    :requirePassword="button.requirePassword"
                    :loading="btnLoaders[index]"
                    @cb="confirm(index)"
                    :text="button.text"
                    :fab="button.fab"
                    :fabIcon="button.fabIcon"
                    :disabled="btnDisabled(button)"
                    :dialogText="button.dialogText"
                />
              </template>
              <span>{{ button.description?button.description:button.name}}</span>
            </v-tooltip>
          </div>
        </div>
      </div>
    </span>
    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from 'vuex'
import utils from "../plugins/helpers"
import confirmedActionButton from './confirmedActionButton.vue';
export default {
  components: {
    confirmedActionButton
  },
  utils,
  name: 'dynamicButtonContainer',
  props: {
    containerId: String,
    data: Object
  },
  computed: {
    ...mapGetters([
      'getEndpoint',
      'getUser',
      'getGlobalValue'
    ]),
  },
  data: () => ({
    dynamicButtons: [],
    btnLoaders: [],
    mainLoader: true,
    snackObj: {
      text: '',
      state: false,
      color: ''
    },
    outlined: false,
    card: false,
    visibleTo: "",
    show: false,
  }),
  async mounted(){
    try {
      if(isNaN(this.containerId)) return;

      let res = await axios.get(`${this.getEndpoint}/api/dynamicButtonContainers/${parseInt(this.containerId)}`)
      if(res.data.error) throw res.data.error
    
      if(res.data.data && res.data.data.dynamicButtons && res.data.data.dynamicButtons.data){
        
        this.dynamicButtons = res.data.data.dynamicButtons.data
        this.outlined = res.data.data.metadata.outlined
        this.card = res.data.data.metadata.card
        if(res.data.data.metadata.visibleTo){
          this.visibleTo = res.data.data.metadata.visibleTo.split(",").map(x=>parseInt(x))
          this.show = this.visibleTo.includes(this.getUser.userTypeId)
        }else{
          this.show = true
        }

        for(let x = 0; x < this.dynamicButtons.length; x++){
          this.btnLoaders.push(false)
        }

      }

    } catch (error) {
      console.log(error.msg || error)
    } finally {
      this.mainLoader = false
    }
  },
  methods: {
    btnDisabled(button){
      let v = false
      let curr = false      
      let leftSide, rightSide

      let d = {
        ...this.data
      }

      if(Object.prototype.hasOwnProperty.call(d, "disabled")) return !!d.disabled

      for(let i of button.disabled){

        rightSide = i.value
        
        if(i.if == "STATUS") leftSide = this.data.status

        if(i.is == 'EQ'){
          if(leftSide == rightSide) curr = true
        }
        
        if(i.is == 'EQS'){
          if(leftSide === rightSide) curr = true
        }

        if(i.is == 'NEQ'){
          if(leftSide != rightSide) curr = true
        }

        if(i.is == 'LT'){
          if(leftSide < rightSide) curr = true
        }

        if(i.is == 'GT'){
          if(leftSide > rightSide) curr = true
        }

        if(i.is == 'LTE'){
          if(leftSide <= rightSide) curr = true
        }

        if(i.is == 'GTE'){
          if(leftSide >= rightSide) curr = true
        }

        if(i.concatOp == "AND"){
          v = v && curr          
        }else if(i.concatOp == "OR"){
          v = v || curr          
        }else{
          v = curr          
        }

      }
      return v
    },
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.state = true;
      this.snackObj.color = color;
    },
    async confirm(index){
      let button = this.dynamicButtons[index]
      this.btnLoaders[index] = true
      this.$forceUpdate()
      if(button.requestType && button.requestEndpoint){

        let obj = {
          method: button.requestType,
          action: button.requestEndpoint,
          id1: this.data.id1?this.data.id1:null,
          id2: this.data.id2?this.data.id2:null,
          useESCPOS: !!button.useESCPOSAppLink,
          noPrint: !!button.noPrint,
          escposAppLink: button.ESCPOSAppLink
        }

        let res = await this.printHandler(obj, index)

        this.$emit('res', res);
      }
    },
    async printHandler(obj, index){ // {id, method, action}
      try {
        this.printHandlerLoading = true
        
        let uri = `${this.getEndpoint}/${obj.action.replace('/:id1', '').replace('/:id2', '')}`
        uri += `${obj.id1?'/'+obj.id1:''}`
        uri += `${obj.id2?'/'+obj.id2:''}`

        let x = await axios[obj.method](uri);
        if (x.data.error) throw x.data.error;

        if(obj.useESCPOS && this.getGlobalValue('useESCPOSPrintForAndroid')==="true" && utils.getMobileOperatingSystem()==="Android"){
          let escposAppLink = this.getGlobalValue('ESCPOSDefaultAppLink') || `print://escpos.org/escpos/[type]/print?srcTp=uri&srcObj=html&numCopies=1&openCashDrawer=0&src='data:text/html,`

          if(obj.escposAppLink){
            escposAppLink = obj.escposAppLink;
          }

          if(this.getUser.metadata.preferredESCPOSAppLink || escposAppLink.includes('[type]')){
            let defAppLink = escposAppLink.includes('[type]')?escposAppLink:`print://escpos.org/escpos/[type]/print?srcTp=uri&srcObj=html&numCopies=1&openCashDrawer=0&src='data:text/html,`
            escposAppLink = defAppLink.replace('[type]', this.getUser.metadata.preferredESCPOSAppLink || 'usb')
          }

          let dynHtml = `${escposAppLink}${encodeURIComponent(x.data.data.job.htmlToPrint)}'`;
          window.location.href = dynHtml;
        }else if(utils.getMobileOperatingSystem()==='iOS'){
          let newWindow = window.open("", "__blank")
          newWindow.document.open()
          newWindow.document.write(x.data.data.job.htmlToPrint)
          newWindow.document.close()
          newWindow.onload = function () {
            newWindow.print(); // Open print dialog
            setTimeout(() => newWindow.close(), 1000); // Auto-close after printing
          }
        }else if(obj.noPrint){
          console.log("Dynamic button specified 'No Print'")
          this.snack("Email Sent", 'success')
        }else{
          const ifrm = document.createElement('iframe');
          ifrm.style.display = "none"; // Hide the iframe
          document.body.appendChild(ifrm);

          const iframeDoc = ifrm.contentDocument || ifrm.contentWindow.document;
          iframeDoc.open();
          iframeDoc.write(x.data.data.job.htmlToPrint); // Write the fabricated HTML content
          iframeDoc.close();

          // Wait for the content to load and then print
          ifrm.onload = function () {
            ifrm.contentWindow.print(); // Trigger the print
            window.addEventListener("afterprint", () => {
              document.body.removeChild(ifrm); // Clean up the iframe after printing
            });
          };
        }

      } catch (error) {
        console.error(error)
        this.snack(error.msg || error, "error")
      } finally {
        this.printHandlerLoading = false
        this.btnLoaders[index] = false
        this.$forceUpdate()
      }
    }
  }
}
</script>
